import {
  AROM_ASSESSMENT,
  FUNCTIONAL_REACH_ASSESSMENT,
  mCTSIB_ASSESSMENT,
} from "../models/Enums";
import { controlAudio, remoteOnlyAudio } from "../utils/assessment-control";
import {
  FunctionalReachAudios,
  GaitAudios,
  TugAudios,
  SitStandAssessmentStates,
  UpperBodyAromAssessmentStates,
  mCTSIBAssessmentStates,
} from "./assessment_states";
// import { ASSESSMENT_STATUSES } from "../movenet/params";

// An Audio for a prompt only remote control mode plays (see remoteOnlyAudio), or null
function remoteOnly(path) {
  const remote_path = remoteOnlyAudio(path);
  return remote_path ? new Audio(remote_path) : null;
}

export class TugAudioPlayer {
  constructor() {
    window.__activeAudioPlayer = this;
    this.skip_instructions = localStorage.getItem("audioInstructionsEnabled") === "false";
    this.assessment_go_audio = new Audio("audios/tug/Go.mp3");
    this.participant_detected = new Audio(
      "audios/tug/participant_detected.mp3",
    );
    this.participant_is_within_the_bounding_box_chair_is_behind = new Audio(
      "audios/tug/participant_is_within_the_bounding_box_Ensure_the_chair_is_safely_behind_them_then_have_them_sit_down.mp3",
    );
    this.raise_arm_to_start_audio = new Audio(
      controlAudio("audios/tug/TUG_StartAssessment_we_are_ready_to_begin.mp3"),
    );

    this.calibrating_the_path_Please_stay_clear_of_the_area = new Audio(
      "audios/tug/calibrating_the_path_Please_stay_clear_of_the_area.mp3",
    );
    this.stand_within_the_box = new Audio(
      "audios/tug/participant_feet_shoud_be_within_the_box_Throughout_this_assessment_the_therapist_should_stand.mp3",
    );

    // this.return_to_start_area = new Audio(
    //   "audios/gait/return_to_start_area.mp3"
    // );

    this.calibrated_audio = new Audio("audios/gait/Calibrated.mp3");
    this.test_completed_audio = new Audio("audios/gait/assessment_ended.mp3");

    this.calibrating_gait_pathway_blocked = new Audio(
      "audios/gait/Mobile-GaitAssessment_007.mp3",
    );

    this.assessment_interrupted_audio = new Audio(
      "audios/gait/assessment_interrupted.mp3",
    );

    this.return_to_start_area = new Audio(
      "audios/gait/return_to_start_area.mp3",
    );

    this.current_playing_audio = null;
    this.skip_available_until = null;
  }

  is_available() {
    if (this.skip_available_until && Date.now() < this.skip_available_until) {
      return false;
    }
    if (!this.current_playing_audio || this.current_playing_audio.ended) {
      return true;
    }
    return false;
  }

  play(state) {
    const isBeepOrError = state === TugAudios.assessment_interrupted || state === TugAudios.pathway_blocked || state === TugAudios.return_to_start_area;
    if (this.skip_instructions && !isBeepOrError) {
      if (state === TugAudios.raiseHand_to_start_and_turn_back) {
        this.skip_available_until = Date.now() + 3000;
      }
      if (this.current_playing_audio) {
        this.current_playing_audio.pause();
        this.current_playing_audio.currentTime = 0;
        this.current_playing_audio = null;
      }
      return;
    }

    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }

    switch (state) {
      case TugAudios.calibrating:
        console.log("Calibrating");
        this.current_playing_audio =
          this.calibrating_the_path_Please_stay_clear_of_the_area;
        this.calibrating_the_path_Please_stay_clear_of_the_area.play();
        break;
      case TugAudios.calibrated:
        console.log("Calibrated");
        this.current_playing_audio = this.calibrated_audio;
        this.calibrated_audio.play();
        break;
      case TugAudios.calibration_complete_stand_within_box:
        console.log("stand_within_the_box");
        this.current_playing_audio = this.stand_within_the_box;
        this.stand_within_the_box.play();
        break;
      case TugAudios.go:
        console.log("play GO audio");
        this.current_playing_audio = this.assessment_go_audio;
        this.assessment_go_audio.play();
        break;
      case TugAudios.participant_detected:
        this.current_playing_audio = this.participant_detected;
        console.log("play participant_detected audio");
        this.participant_detected.play();
        break;

      case TugAudios.raiseHand_to_start_and_turn_back:
        console.log("gait pathway calibration start");
        this.current_playing_audio = this.raise_arm_to_start_audio;
        this.raise_arm_to_start_audio.play();
        break;

      case TugAudios.place_chair_behind_patient:
        console.log("participant_is_within_the_bounding_box_chair_is_behind");
        this.current_playing_audio =
          this.participant_is_within_the_bounding_box_chair_is_behind;
        this.participant_is_within_the_bounding_box_chair_is_behind.play();
        break;

      case TugAudios.assessment_complete:
        console.log("play test complete audio");
        this.current_playing_audio = this.test_completed_audio;
        this.test_completed_audio.play();
        break;
      case TugAudios.pathway_blocked:
        console.log("gait pathway blocked");
        this.current_playing_audio = this.calibrating_gait_pathway_blocked;
        this.calibrating_gait_pathway_blocked.play();
        break;
      case TugAudios.assessment_interrupted:
        console.log("assessment interrupted");
        this.current_playing_audio = this.assessment_interrupted_audio;
        this.assessment_interrupted_audio.play();
        break;
      case TugAudios.return_to_start_area:
        console.log("play return to start area");
        this.current_playing_audio = this.return_to_start_area;
        this.return_to_start_area.play();
        break;

      // case AssessmentStates.test_in_progress:
      //   console.log("play test in progress audio");
      //   break;

      default:
        break;
    }
  }

  stop() {
    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }
  }
}
export class AudioPlayer {
  constructor() {
    window.__activeAudioPlayer = this;
    this.skip_instructions = localStorage.getItem("audioInstructionsEnabled") === "false";
    this.return_to_start_area = new Audio(
      "audios/gait/return_to_start_area.mp3",
    );
    this.stand_in_starting_area = new Audio(
      "audios/gait/Mobile-GaitAssessment_001.mp3",
    );
    this.raise_arm_to_start_audio = new Audio(controlAudio("audios/gait/Gait_Start_Assessment_we_are_ready_to_begin.mp3"));
    this.calibrating_gait_pathway = new Audio(
      "audios/gait/Mobile-GaitAssessment_002.mp3",
    );
    this.calibrating_gait_pathway_blocked = new Audio(
      "audios/gait/Mobile-GaitAssessment_007.mp3",
    );
    this.assessment_go_audio = new Audio("audios/gait/Assessment_Go.mp3");
    this.test_completed_audio = new Audio("audios/gait/assessment_ended.mp3");
    this.assessment_interrupted_audio = new Audio(
      "audios/gait/assessment_interrupted.mp3",
    );

    this.calibrated_audio = new Audio("audios/gait/Calibrated.mp3");
    this.current_playing_audio = null;
  }

  is_available() {
    if (this.skip_available_until && Date.now() < this.skip_available_until) {
      return false;
    }
    if (!this.current_playing_audio || this.current_playing_audio.ended) {
      return true;
    }
    return false;
  }

  play(state) {
    const isBeepOrError = state === GaitAudios.assessment_interrupted || state === GaitAudios.pathway_blocked || state === GaitAudios.return_to_start_area;
    if (this.skip_instructions && !isBeepOrError) {
      if (state === GaitAudios.raise_arm_to_start_audio) {
        this.skip_available_until = Date.now() + 3000;
      }
      return;
    }

    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }

    switch (state) {
      case GaitAudios.stand_in_starting_area:
        this.current_playing_audio = this.stand_in_starting_area;
        console.log("play stand in starting area audio");
        this.stand_in_starting_area.play();
        break;

      case GaitAudios.pathway_calibration_start:
        console.log("gait pathway calibration start");
        this.current_playing_audio = this.calibrating_gait_pathway;
        this.calibrating_gait_pathway.play();
        break;

      case GaitAudios.assessment_interrupted:
        console.log("assessment interrupted");
        this.current_playing_audio = this.assessment_interrupted_audio;
        this.assessment_interrupted_audio.play();
        break;
      case GaitAudios.pathway_blocked:
        console.log("gait pathway blocked");
        this.current_playing_audio = this.calibrating_gait_pathway_blocked;
        this.calibrating_gait_pathway_blocked.play();
        break;
      case GaitAudios.calibrated:
        console.log("Calibrated");
        this.current_playing_audio = this.calibrated_audio;
        this.calibrated_audio.play();
        break;
      case GaitAudios.assessment_go_audio:
        console.log("play start gesture issued audio");
        this.current_playing_audio = this.assessment_go_audio;
        this.assessment_go_audio.play();
        break;
      case GaitAudios.assessment_complete:
        console.log("play test complete audio");
        this.current_playing_audio = this.test_completed_audio;
        this.test_completed_audio.play();
        break;
      case GaitAudios.return_to_start_area:
        console.log("play return to start area");
        this.current_playing_audio = this.return_to_start_area;
        this.return_to_start_area.play();
        break;
      case GaitAudios.raise_arm_to_start_audio:
        console.log("play raise arm to start audio");
        this.current_playing_audio = this.raise_arm_to_start_audio;
        this.raise_arm_to_start_audio.play();
        break;

      // case AssessmentStates.test_in_progress:
      //   console.log("play test in progress audio");
      //   break;

      default:
        break;
    }
  }

  stop() {
    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }
  }
}

export class FunctionalReachAudioPlayer {
  constructor() {
    window.__activeAudioPlayer = this;
    this.skip_instructions = localStorage.getItem("audioInstructionsEnabled") === "false";
    this.participant_should_stand_with_in_the_starting_box = new Audio(
      "audios/functionalReach/participant_should_stand_with_in_the_starting_box.mp3",
    );

    this.calibration_1 = {
      [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: new Audio(
        "audios/functionalReach/phase1_faceForwardTowardsTheCamera.mp3",
      ),
      // [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: new Audio(
      //   "audios/functionalReach/extend_your_right_arm.mp3"
      // ),
      [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: new Audio(
        "audios/functionalReach/phase3_ForwardReachParticipant_should_turn_to_their_right_side_facing_away_from_the_camera.mp3",
      ),
    };
    this.hand_orientation = {
      [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: new Audio(
        "audios/functionalReach/left_Reach_Stand_up_straight_and_extend_your_left_arm.mp3",
      ),
      [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: new Audio(
        "audios/functionalReach/rightReachStand_up_straight_and_extend_your_right_arm.mp3",
      ),
      [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: new Audio(
        "audios/functionalReach/extend_both_your_hands_and_Hold_for_a_moment.mp3",
      ),
    };

    this.hand_orientation_2 = {
      [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: new Audio(
        "audios/functionalReach/on_go_Reach_your_arm_to_the_left_as_far_as_you_can.mp3",
      ),
      [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: new Audio(
        "audios/functionalReach/on_go_Reach_your_arm_to_the_right_as_far_as_you_can.mp3",
      ),
      [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: new Audio(
        "audios/functionalReach/on_go_Reach_your_arm_forward_as_far_as_you_can.mp3",
      ),
    };

    this.readyState = {
      [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: new Audio(
        controlAudio("audios/functionalReach/Ready_Therapist_should_raise_one_arm_or_say_we_are_ready_to_begin.mp3"),
      ),
      [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: null,
      [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: null,
    };

    this.you_have_10_seconds_to_perform_this_movement = new Audio(
      "audios/functionalReach/goYou_have_10_seconds_to_perform_this_movement_as_many_times_as_required.mp3",
    );

    this.assessment_interrupted = new Audio(
      "audios/sitstand/assessment_interrupted.mp3",
    );

    this.phaseCompletion = {
      [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: new Audio(
        "audios/functionalReach/phase1Completion.mp3",
      ),
      [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: new Audio(
        "audios/functionalReach/phase2Completion.mp3",
      ),
      [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: new Audio(
        "audios/functionalReach/phase3Completion.mp3",
      ),
    };

    this.beepSound = new Audio("audios/functionalReach/beepSound.mp3");

    this.participant_detected = new Audio(
      "audios/mctsib/participant_detected.mp3",
    );

    this.current_playing_audio = null;
    this.skip_available_until = null;
  }

  is_available() {
    if (this.skip_available_until && Date.now() < this.skip_available_until) {
      return false;
    }
    if (!this.current_playing_audio || this.current_playing_audio.ended) {
      return true;
    }
    return false;
  }

  play(state, assessment_type) {
    const isBeepOrError = state === FunctionalReachAudios.beepSound || state === FunctionalReachAudios.assessment_interrupted;
    if (this.skip_instructions && !isBeepOrError) {
      if (state === FunctionalReachAudios.readyState && assessment_type === FUNCTIONAL_REACH_ASSESSMENT.Left_Reach) {
        this.skip_available_until = Date.now() + 3000;
      }
      if (this.current_playing_audio) {
        this.current_playing_audio.pause();
        this.current_playing_audio.currentTime = 0;
        this.current_playing_audio = null;
      }
      return;
    }

    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }

    switch (state) {
      case FunctionalReachAudios.calibration_1:
        this.current_playing_audio = this.calibration_1[assessment_type];
        console.log("play phase1_faceForwardTowardsTheCamera");
        this.calibration_1[assessment_type].play();
        break;
      case FunctionalReachAudios.phaseCompletion:
        this.current_playing_audio = this.phaseCompletion[assessment_type];
        console.log("play phase1Completion");
        this.phaseCompletion[assessment_type].play();
        break;
      case FunctionalReachAudios.beepSound:
        this.current_playing_audio = this.beepSound;
        console.log("play beepSound");
        this.beepSound.play();
        break;

      case FunctionalReachAudios.hand_orientation:
        console.log("extend_your_left_arm");
        this.current_playing_audio = this.hand_orientation[assessment_type];
        this.hand_orientation[assessment_type].play();
        break;
      case FunctionalReachAudios.participant_should_stand_with_in_the_starting_box:
        console.log("participant_should_stand_with_in_the_starting_box");
        this.current_playing_audio =
          this.participant_should_stand_with_in_the_starting_box;
        this.participant_should_stand_with_in_the_starting_box.play();
        break;

      case FunctionalReachAudios.hand_orientation_2:
        console.log("play reach_as_far_as_you_can");
        this.current_playing_audio = this.hand_orientation_2[assessment_type];
        this.hand_orientation_2[assessment_type].play();
        break;

      case FunctionalReachAudios.readyState:
        console.log("play therapist_should_raise_one_arm_to_start_left_reach");
        if (this.readyState[assessment_type]) {
          this.current_playing_audio = this.readyState[assessment_type];
          this.readyState[assessment_type].play();
        } else {
          this.current_playing_audio = null;
        }
        break;

      case FunctionalReachAudios.you_have_10_seconds_to_perform_this_movement:
        console.log("play you_have_10_seconds_to_perform_this_movement");
        this.current_playing_audio =
          this.you_have_10_seconds_to_perform_this_movement;
        this.you_have_10_seconds_to_perform_this_movement.play();
        break;

      case FunctionalReachAudios.participant_detected:
        console.log("play participant_detected audio");
        this.current_playing_audio = this.participant_detected;
        this.participant_detected.play();
        break;

      case FunctionalReachAudios.assessment_interrupted:
        console.log("play assessment_interrupted");
        this.current_playing_audio = this.assessment_interrupted;
        this.assessment_interrupted.play();


        // LIVE CAMERA: Modal triggered by ASSESSMENT_STATUSES.assessment_error flag instead
        // const errorBtn = document.getElementById("hdnAssessementErrorPopup");
        // if (errorBtn) {
        //   console.log("LIVE CAMERA: Auto-triggering assessment error modal from audio player");
        //   setTimeout(() => errorBtn.click(), 500); // Small delay to let audio start
        // }
        break;

      default:
        break;
    }
  }
}
export class SitStandAudioPlayer {
  constructor() {
    window.__activeAudioPlayer = this;
    this.skip_instructions = localStorage.getItem("audioInstructionsEnabled") === "false";
    this.setup_instructions = new Audio(
      "audios/functionalReach/participant_should_stand_with_in_the_starting_box.mp3",
    );
    this.assessment_started_audio = new Audio(
      controlAudio("audios/sitstand/standing_height_gesture_we_are_ready.mp3"),
    );
    this.calibration_complete_audio = new Audio(
      "audios/sitstand/calibration_complete.mp3",
    );
    this.start_assessment_audio = new Audio(
      "audios/sitstand/start_assessment.mp3",
    );
    this.assessment_ended = new Audio("audios/sitstand/assessment_ended.mp3");
    this.assessment_interrupted_audio = new Audio(
      "audios/sitstand/assessment_interrupted.mp3",
    );
    this.assessment_go = new Audio("audios/sitstand/Assessment_Go.mp3");
    this.current_playing_audio = null;
  }

  is_available() {
    if (this.skip_available_until && Date.now() < this.skip_available_until) {
      return false;
    }
    if (!this.current_playing_audio || this.current_playing_audio.ended) {
      return true;
    }
    return false;
  }

  play(state) {
    const isBeepOrError = state === SitStandAssessmentStates.assessment_interrupted;
    if (this.skip_instructions && !isBeepOrError) {
      if (state === SitStandAssessmentStates.with_in_bounds) {
        this.skip_available_until = Date.now() + 3000;
      }
      if (state === SitStandAssessmentStates.patient_seated_completely) {
        document.getElementById("hdnCountDownCompletePopup")?.click();
      }
      return;
    }

    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }

    switch (state) {
      case SitStandAssessmentStates.begin_assessment:
        console.log("play WalkBack start audio");
        this.current_playing_audio = this.setup_instructions;
        this.setup_instructions.play();
        break;

      case SitStandAssessmentStates.with_in_bounds:
        console.log("play rise hand audio");
        this.current_playing_audio = this.assessment_started_audio;
        this.assessment_started_audio.play();
        break;

      case SitStandAssessmentStates.stand_gesture_issued:
        console.log("Calibration complete");
        this.current_playing_audio = this.calibration_complete_audio;
        this.calibration_complete_audio.play();
        break;

      case SitStandAssessmentStates.patient_seated_completely:
        console.log("play Sit Down audio");
        this.current_playing_audio = this.start_assessment_audio;
        this.start_assessment_audio.play();
        break;

      case SitStandAssessmentStates.about_to_start_test:
        console.log("Go!");
        this.current_playing_audio = this.assessment_go;
        this.assessment_go.play();
        break;

      case SitStandAssessmentStates.test_complete:
        this.current_playing_audio = this.assessment_ended;
        this.assessment_ended.play();
        console.log("play test complete audio");
        break;

      case SitStandAssessmentStates.assessment_interrupted:
        this.current_playing_audio = this.assessment_interrupted_audio;
        this.assessment_interrupted_audio.play();
        console.log("play assessment error audio");
        break;
      default:
        break;
    }
  }

  stop() {
    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }
  }
}

export class UpperBodyAromAudioPlayer {
  constructor() {
    window.__activeAudioPlayer = this;
    this.skip_instructions = localStorage.getItem("audioInstructionsEnabled") === "false";
    this.setup_instructions = new Audio(
      "audios/upper_body_arom/participantShouldStandWithinTheBox.mp3",
    );

    this.assessment_started_audio = new Audio(
      "audios/sitstand/standing_height_gesture.mp3",
    );

    this.calibration_complete_audio = new Audio("audios/gait/Calibrated.mp3");

    this.aromPalmFacingCamera = {
      [AROM_ASSESSMENT.Shoulder_AAA]: new Audio(
        "audios/upper_body_arom/aromPalmFacingCameraPh1.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/aromPalmFacingCameraPh2.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/aromPalmFacingCameraPh3.mp3",
      ),
    };

    this.handOrientation = {
      [AROM_ASSESSMENT.Shoulder_AAA]: new Audio(
        "audios/upper_body_arom/handOrientationAdductionAbduction.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/handOrientationLeftShoulderFAE.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/handOrientationRightShoulderFAE.mp3",
      ),
      [AROM_ASSESSMENT.Left_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/handOrientationLeftElbow.mp3",
      ),
      [AROM_ASSESSMENT.Right_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/handOrientationRightElbow.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/handOrientationLeftShoulderIAE.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/handOrientationRightShoulderIAE.mp3",
      ),
    };

    this.raise_hand_gif = {
      [AROM_ASSESSMENT.Shoulder_AAA]: new Audio(
        "audios/upper_body_arom/gifAudioAddAbd.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/gifAudioLeftShoulderFAE.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/gifAudioRightShoulderFAE.mp3",
      ),
      [AROM_ASSESSMENT.Left_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/gifAudioLeftElbow.mp3",
      ),
      [AROM_ASSESSMENT.Right_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/gifAudioRightElbow.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/gifAudioLeftShoulderIAERotation.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/gifAudioRightShoulderIAERotation.mp3",
      ),
    };
    // Audio files are named from the patient's perspective (Left/Right),
    // but code keys use the camera's perspective (mirrored). So Left code key
    // maps to Right audio file and vice versa.
    // With hand gestures only the first movement has a prompt; with the remote each movement tells
    // the therapist to press Start.
    this.TherapistReadyMessage = {
      [AROM_ASSESSMENT.Shoulder_AAA]: new Audio(
        controlAudio("audios/upper_body_arom/AROM_Shoulder_Abduction_and_Adduction_we_are_ready_to_begin.mp3"),
      ),
      [AROM_ASSESSMENT.Left_Shoulder_FAE]: remoteOnly(
        "audios/upper_body_arom/remote/AROM_RightShoulderFAE_remote.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_FAE]: remoteOnly(
        "audios/upper_body_arom/remote/AROM_LeftShoulderFAE_remote.mp3",
      ),
      [AROM_ASSESSMENT.Left_Elbow_FAE]: remoteOnly(
        "audios/upper_body_arom/remote/AROM_RightElbow_remote.mp3",
      ),
      [AROM_ASSESSMENT.Right_Elbow_FAE]: remoteOnly(
        "audios/upper_body_arom/remote/AROM_LeftElbow_remote.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: remoteOnly(
        "audios/upper_body_arom/remote/AROM_RightShoulderRotation_remote.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: remoteOnly(
        "audios/upper_body_arom/remote/AROM_LeftShoulderRotation_remote.mp3",
      ),
    };
    this.shoulderAbductionAdduction = new Audio(
      "audios/upper_body_arom/shoulderAbductionAdduction.mp3",
    );

    this.assessment_started = {
      [AROM_ASSESSMENT.Shoulder_AAA]: new Audio(
        "audios/upper_body_arom/assessmentStartedAddAbd.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/assessmentStartedLeftShoulderFAE.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/assessmentStartedRightShoulderFAE.mp3",
      ),
      [AROM_ASSESSMENT.Left_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/assessmentStartedLeftElbow.mp3",
      ),
      [AROM_ASSESSMENT.Right_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/assessmentStartedRightElbow.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/assessmentStartedLeftShoulderIAERotation.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/assessmentStartedRightShoulderIAERotation.mp3",
      ),
    };

    this.lowerYourArms = new Audio("audios/upper_body_arom/3scountdown.mp3");
    this.phaseCompletion = {
      [AROM_ASSESSMENT.Shoulder_AAA]: new Audio(
        "audios/upper_body_arom/phase1Completion.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/merticSaved.mp3",
      ),
      [AROM_ASSESSMENT.Left_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/merticSaved.mp3",
      ),
      [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/phase2Completion.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/merticSaved.mp3",
      ),
      [AROM_ASSESSMENT.Right_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/merticSaved.mp3",
      ),
      [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/phase3Completion.mp3",
      ),
    };
    this.assessment_interrupted_audio = new Audio(
      "audios/sitstand/assessment_interrupted.mp3",
    );
    this.current_playing_audio = null;
  }

  is_available() {
    if (this.skip_available_until && Date.now() < this.skip_available_until) {
      return false;
    }
    if (!this.current_playing_audio || this.current_playing_audio.ended) {
      return true;
    }
    return false;
  }

  play(state, arom_assessment_type) {
    const isBeepOrError = state === UpperBodyAromAssessmentStates.abduction_adduction_assessment || state === UpperBodyAromAssessmentStates.assessment_interrupted;
    if (this.skip_instructions && !isBeepOrError) {
      if (state === UpperBodyAromAssessmentStates.abduction_adduction_calibration_3) {
        this.skip_available_until = Date.now() + 3000;
      }
      if (this.current_playing_audio) {
        this.current_playing_audio.pause();
        this.current_playing_audio.currentTime = 0;
        this.current_playing_audio = null;
      }
      return;
    }

    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }

    switch (state) {
      case UpperBodyAromAssessmentStates.begin_assessment:
        console.log("play WalkBack start audio");
        this.current_playing_audio = this.setup_instructions;
        this.setup_instructions.play();
        break;

      case UpperBodyAromAssessmentStates.with_in_bounds:
        console.log("play rise hand audio");
        this.current_playing_audio = this.assessment_started_audio;
        this.assessment_started_audio.play();
        break;

      case UpperBodyAromAssessmentStates.calibrated:
        console.log("play Calibrated audio");
        this.current_playing_audio = this.calibration_complete_audio;
        this.calibration_complete_audio.play();
        break;

      case UpperBodyAromAssessmentStates.calibration_1:
        console.log("play calibration_1 - aromPalmFacingCamera audio");
        this.current_playing_audio =
          this.aromPalmFacingCamera[arom_assessment_type];
        this.aromPalmFacingCamera[arom_assessment_type].play();
        break;

      case UpperBodyAromAssessmentStates.hand_orientation:
        console.log(
          "play hand_orientation - hand_orientation audio: ",
          arom_assessment_type,
        );
        this.current_playing_audio = this.handOrientation[arom_assessment_type];
        this.handOrientation[arom_assessment_type].play();
        break;

      case UpperBodyAromAssessmentStates.abduction_adduction_calibration_2:
        console.log(
          "play abduction_adduction_calibration_2 - raise_hand_gif audio",
        );
        this.current_playing_audio = this.raise_hand_gif[arom_assessment_type];
        this.raise_hand_gif[arom_assessment_type].play();
        break;

      case UpperBodyAromAssessmentStates.abduction_adduction_calibration_3:
        console.log(
          "play abduction_adduction_calibration_3 - TherapistReadyMessage audio",
        );
        if (this.TherapistReadyMessage[arom_assessment_type]) {
          this.current_playing_audio =
            this.TherapistReadyMessage[arom_assessment_type];
          this.TherapistReadyMessage[arom_assessment_type].play();
        } else {
          this.current_playing_audio = null;
        }
        break;

      case UpperBodyAromAssessmentStates.abduction_adduction_calibration_4:
        console.log(
          "play abduction_adduction_calibration_4 - assessmentStarted audio",
        );
        this.current_playing_audio =
          this.assessment_started[arom_assessment_type];
        this.assessment_started[arom_assessment_type].play();
        break;

      case UpperBodyAromAssessmentStates.abduction_adduction_assessment:
        console.log("play abduction_adduction_assessment - beep sound");
        this.current_playing_audio = this.lowerYourArms;
        this.lowerYourArms.play();
        break;

      case UpperBodyAromAssessmentStates.post_abduction_adduction_modal:
        console.log(
          "play post_abduction_adduction_modal - phaseCompletion audio",
        );
        this.current_playing_audio = this.phaseCompletion[arom_assessment_type];
        this.phaseCompletion[arom_assessment_type].play();
        break;

      case UpperBodyAromAssessmentStates.assessment_interrupted:
        console.log("play assessment interrupted audio");
        this.current_playing_audio = this.assessment_interrupted_audio;
        this.assessment_interrupted_audio.play();
        break;
      default:
        break;
    }
  }

  stop() {
    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }
  }
}
export class mCTSIBAudioPlayer {
  constructor() {
    window.__activeAudioPlayer = this;
    this.skip_instructions = localStorage.getItem("audioInstructionsEnabled") === "false";
    this.skip_available_until = null;
    this.calibratingThePath = new Audio(
      "audios/mctsib/Calibrating_the_path.Please_stay_clear_of_the-area.mp3"
    );

    this.calibrating_gait_pathway_blocked = new Audio(
      "audios/mctsib/pathwayBlocked.mp3"
    );

    this.assessment_interrupted = new Audio(
      "audios/mctsib/assessment_interrupted.mp3"
    );

    this.goAudio = new Audio("audios/mctsib/Assessment_Go.mp3");

    this.beepSound = new Audio("audios/mctsib/3scountdown.mp3");

    this.standWithInTheBox = new Audio(
      "audios/mctsib/Calibration_complete.Participant_should_stand_within_the_bounding_box.mp3"
    );

    this.openYourEyes = new Audio("audios/mctsib/Open_your_eyes.mp3");
    this.participant_detected = new Audio(
      "audios/mctsib/participant_detected.mp3"
    );
    this.feetShouldBeInTheBox = new Audio(
      "audios/mctsib/Participant's_feet_shoudl_be_within_the_box.Throughout_this_assessment,the_therapist_should_stand.mp3"
    );

    this.phaseCompletion = {
      [mCTSIB_ASSESSMENT.Open_Eyes]: new Audio(
        "audios/mctsib/Phase1complete!.mp3"
      ),
      [mCTSIB_ASSESSMENT.Closed_Eyes]: new Audio(
        "audios/mctsib/Phase2Complete!.mp3"
      ),
      [mCTSIB_ASSESSMENT.Foam_Open_Eyes]: new Audio(
        "audios/mctsib/Phase3Complete!.mp3"
      ),
      [mCTSIB_ASSESSMENT.Foam_Closed_Eyes]: new Audio(
        "audios/mctsib/Phase4complete!.mp3"
      ),
    };

    this.phaseStart = {
      [mCTSIB_ASSESSMENT.Open_Eyes]: new Audio(
        "audios/mctsib/Phase_1_Eyes_open_on_floor.mp3"
      ),
      [mCTSIB_ASSESSMENT.Closed_Eyes]: new Audio(
        "audios/mctsib/Phase_2_Eyes_Closed_on_Floor.mp3"
      ),
      [mCTSIB_ASSESSMENT.Foam_Open_Eyes]: new Audio(
        "audios/mctsib/Phase_3_Eyes_Open_on_Foam.mp3"
      ),
      [mCTSIB_ASSESSMENT.Foam_Closed_Eyes]: new Audio(
        "audios/mctsib/Phase_4_Eyes_closed_on_Foam.mp3"
      ),
    };

    this.handRaise = {
      [mCTSIB_ASSESSMENT.Open_Eyes]: new Audio(
        controlAudio("audios/mCTSIB/mCTSIB_Start_Assessment_we_are_ready_to_begin.mp3")
      ),
      [mCTSIB_ASSESSMENT.Closed_Eyes]: null,
      [mCTSIB_ASSESSMENT.Foam_Open_Eyes]: null,
      [mCTSIB_ASSESSMENT.Foam_Closed_Eyes]: null,
    };

    this.TherapistReadyMessage = {
      [AROM_ASSESSMENT.Shoulder_AAA]: new Audio(
        "audios/upper_body_arom/TherapistReadyAudioAddAbd.mp3"
      ),
      [AROM_ASSESSMENT.Left_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/TherapistReadyAudioLeftShoulderFAE.mp3"
      ),
      [AROM_ASSESSMENT.Right_Shoulder_FAE]: new Audio(
        "audios/upper_body_arom/TherapistReadyAudioRightShoulderFAE.mp3"
      ),
      [AROM_ASSESSMENT.Left_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/TherapistReadyAudioLeftElbow.mp3"
      ),
      [AROM_ASSESSMENT.Right_Elbow_FAE]: new Audio(
        "audios/upper_body_arom/TherapistReadyAudioRightElbow.mp3"
      ),
      [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/TherapistReadyAudioLeftShoulderIAERotation.mp3"
      ),
      [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: new Audio(
        "audios/upper_body_arom/TherapistReadyAudioRightShoulderIAERotation.mp3"
      ),
    };

    this.current_playing_audio = null;
  }

  is_available() {
    if (this.skip_available_until && Date.now() < this.skip_available_until) {
      return false;
    }
    if (!this.current_playing_audio || this.current_playing_audio.ended) {
      return true;
    }
    return false;
  }

  play(state, mCTSIB_type) {
    const isBeepOrError = state === mCTSIBAssessmentStates.assessment_In_progress || state === mCTSIBAssessmentStates.assessment_interrupted || state === mCTSIBAssessmentStates.pathwayBlocked;
    if (this.skip_instructions && !isBeepOrError) {
      if (state === mCTSIBAssessmentStates.raise_hand && mCTSIB_type === mCTSIB_ASSESSMENT.Open_Eyes) {
        this.skip_available_until = Date.now() + 3000;
      }
      if (this.current_playing_audio) {
        this.current_playing_audio.pause();
        this.current_playing_audio.currentTime = 0;
        this.current_playing_audio = null;
      }
      return;
    }

    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }

    switch (state) {
      case mCTSIBAssessmentStates.calculatingDepth:
        console.log("calculatingDepth");
        this.current_playing_audio = this.calibratingThePath;
        this.calibratingThePath.play();
        break;

      case mCTSIBAssessmentStates.calibrated:
        console.log("calibrated");
        this.current_playing_audio = this.standWithInTheBox;
        this.standWithInTheBox.play();

        // Play second audio after first one finishes
        this.standWithInTheBox.onended = () => {
          this.current_playing_audio = this.feetShouldBeInTheBox;
          this.feetShouldBeInTheBox.play();
        };
        break;

      case mCTSIBAssessmentStates.pathwayBlocked:
        console.log("pathway blocked");
        this.current_playing_audio = this.calibrating_gait_pathway_blocked;
        this.calibrating_gait_pathway_blocked.play();
        break;

      case mCTSIBAssessmentStates.assessment_interrupted:
        console.log("pathway blocked");
        this.current_playing_audio = this.assessment_interrupted;
        this.assessment_interrupted.play();
        break;

      case mCTSIBAssessmentStates.calibration_1:
        console.log("play calibration_1 - audio");
        this.current_playing_audio = this.phaseStart[mCTSIB_type];
        this.phaseStart[mCTSIB_type].play();
        break;

      case mCTSIBAssessmentStates.gesture_detection:
        console.log("play calibration_1 - audio");
        this.current_playing_audio = this.goAudio;
        this.goAudio.play();
        break;

      case mCTSIBAssessmentStates.post_assessment_modal:
        console.log("play calibration_1 - audio");
        this.current_playing_audio = this.phaseCompletion[mCTSIB_type];
        this.phaseCompletion[mCTSIB_type].play();
        break;
      case mCTSIBAssessmentStates.raise_hand:
        console.log("play calibration_1 - audio");
        if (this.handRaise[mCTSIB_type]) {
          this.current_playing_audio = this.handRaise[mCTSIB_type];
          this.handRaise[mCTSIB_type].play();
        } else {
          this.current_playing_audio = null;
        }
        break;

      case mCTSIBAssessmentStates.assessment_In_progress:
        console.log("play abduction_adduction_assessment - beep sound");
        this.current_playing_audio = this.beepSound;
        this.beepSound.play();
        break;

      default:
        break;
    }
  }

  stop() {
    if (this.current_playing_audio) {
      this.current_playing_audio.pause();
      this.current_playing_audio.currentTime = 0;
    }
  }
}
